import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65a91b94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-list-page" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "ws_common_operation ws_mb20" }

import { onMounted, ref } from 'vue'
import { PAGE_SIZES, CODE_ENUM } from '@/common'
import i18n from '@/i18n'
import { querySitePage, deleteSiteInfo } from '@/api'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import OperationButtonList from '@/components/operation-button-list'
import SiteForm from './components/site-form-drawer.vue'
import { useRouter } from 'vue-router'
import moment from 'moment'
import { msgbox } from '@/utils'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()

const t = i18n.global.t

const advancedRef = ref()

const buttonList = ref([
  {
    type: 'edit',
    text: t('D_INFO.btnEdit'),
  },
  {
    type: 'delete',
    text: t('D_INFO.btnDelete'),
  },
  {
    type: 'detail',
    text: t('D_INFO.btnDetail'),
  },
])

const tableData: any = ref([])
const formInline = ref({
  siteName: '',
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const tableLoading = ref(false)

const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData()
  const { data, reset } = queryData || {}

  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true

  const res: any = await querySitePage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === 0) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  fetchList()
})

const columns = [
  {
    label: t('SITE.col1'),
    prop: 'name',
  },
  {
    label: t('SITE.col2'),
    prop: 'orgName',
  },
  {
    label: t('SITE.col3'),
    prop: 'deviceTotal',
  },
  {
    label: t('SITE.col4'),
    prop: 'describe',
    formatter: ({ describe }: any) => {
      return describe || '-'
    },
  },
  {
    label: t('SITE.col5'),
    prop: '',
    formatter: () => {
      return moment().format('YYYY-MM-DD HH:mm:ss')
    },
  },
]

const toDetail = ({ id }: any) => {
  router.push({
    path: '/site/site-list/site-detail',
    query: {
      id,
    },
  })
}

const siteConf = ref({
  visible: false,
  data: {},
})
const handleSiteConf = (data: any) => {
  siteConf.value = {
    visible: true,
    data,
  }
}

const toDelete = (row: any) => {
  msgbox({
    tip: t('SITE.delTip'),
    thenFn: () => handleDelete(row),
  })
}

const handleDelete = async ({ id }: any) => {
  const res: any = await deleteSiteInfo({ siteIds: [id] })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AdvancedQueryLayout), {
        ref_key: "advancedRef",
        ref: advancedRef,
        model: formInline.value,
        onFetchList: fetchList,
        "label-width": 92,
        border: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('SITE.siteName'),
            prop: "siteName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.siteName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.siteName) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSiteConf({}))),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('SITE.btnAdd')), 1)
            ]),
            _: 1
          })
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "ws_common_table",
          data: tableData.value,
          stripe: ""
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, {
              description: _ctx.$t('D_INFO.noData')
            }, null, 8, ["description"])
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
              return _createVNode(_component_el_table_column, _mergeProps({
                key: item.prop
              }, {
            ...item,
          }, { "show-overflow-tooltip": "" }), null, 16)
            }), 64)),
            _createVNode(_component_el_table_column, {
              prop: "operation",
              label: _ctx.$t('D_INFO.colOperation'),
              width: "280"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_unref(OperationButtonList), {
                  buttonList: buttonList.value,
                  scope: scope.row,
                  onOnDetail: toDetail,
                  onOnEdit: handleSiteConf,
                  onOnDelete: toDelete
                }, null, 8, ["buttonList", "scope"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _createVNode(SiteForm, {
      visible: siteConf.value.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((siteConf.value.visible) = $event)),
      data: siteConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})